const zIndexMultiplier = 1000000000;

export const zIndexLayer = {
  modal: 2 * zIndexMultiplier,
  tooltip: 2.1 * zIndexMultiplier,
  deactivation: 3 * zIndexMultiplier
};
